module.exports = __webpack_public_path__ + "img/egg_beta.9ab6ed76.png";